import React from "react";

const DurationMaxError = props => (
  <span className="duration-max-error hidden">
    Start duration cannot exceed end duration.
  </span>
);

export default DurationMaxError;
